import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { borderRadius } from "@mui/system";

function InfoModalAvaliacao({ text, title }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
      }}
    >
      <Typography
        sx={{
          color: "var(--cor-pretoApoio)",
          fontWeight: 700,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: "var(--cor-pretoApoio)",
          fontFamily: "Inter",
          fontWeight: 500,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

export default InfoModalAvaliacao;
